import reservedData from '../data/reserved.json'

/**
 * Slugs that can never be color pages. The base list is 508 common words;
 * the site's own routes are added so that
 * /about, /privacy-policy etc. always win over a color named the same.
 */
const SITE_ROUTES = [
  'about',
  'contact',
  'faq',
  'registry',
  'store',
  'register',
  'api-docs',
  'privacy-policy',
  'terms-of-service',
  'color',
  'images',
  'assets',
]

const reservedSet = new Set<string>([
  ...reservedData.reserved.map((w) => w.toLowerCase()),
  ...SITE_ROUTES,
])

export function isReserved(slug: string): boolean {
  return reservedSet.has(slug.trim().toLowerCase())
}

export const reservedCount = reservedSet.size
